import React from "react"
import propTypes from "prop-types"
import { lenguage, dateConfig } from "config/format-date"
import { Button } from "reactstrap"

const CashCutItemList = ({ item, variant = "legacy", onView }) => {
  const date = new Date(item.date.replace("Z", ""))
  const formattedDate = date.toLocaleString(lenguage, dateConfig)
  const styleCenterTable = { verticalAlign: "middle" }

  function currencyFormatter({ currency, value }) {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      minimumFractionDigits: 2,
      currency,
    })
    return formatter.format(value ?? 0)
  }

  const renderPrintButton = () => (
    <Button type="button" color="success" onClick={() => (onView ? onView(item) : null)}>
      <i className="fa fa-list" />
    </Button>
  )

  const invoicedTotal = Number(item.invoiced_total ?? item.total_invoices ?? 0)
  const difference = Number(item.total_tickets || 0) - invoicedTotal

  if (variant === "daily") {
    return (
      <tr key={item.id}>
        <td style={styleCenterTable} className="text-cell">
          {item.type_cash_cut}
        </td>
        <td style={styleCenterTable} className="text-cell">
          {formattedDate}
        </td>
        <td style={styleCenterTable} className="money-cell">{currencyFormatter({ 
          currency: "USD", value: item.total_tickets })}</td>
        <td style={styleCenterTable} className="money-cell">{currencyFormatter({ 
          currency: "USD", value: invoicedTotal })}</td>
        <td style={styleCenterTable} className="money-cell">{currencyFormatter({ 
          currency: "USD", value: difference })}</td>
        <td style={styleCenterTable} className="text-center">{renderPrintButton()}</td>
      </tr>
    )
  }

  return (
    <tr key={item.id}>
      <td style={styleCenterTable} className="text-cell">
        {item.type_cash_cut}
      </td>
      <td style={styleCenterTable} className="text-cell">
        {formattedDate}
      </td>
      <td style={styleCenterTable} className="money-cell">{currencyFormatter({ 
        currency: "USD", value: item.total_tickets })}</td>
      <td style={styleCenterTable} className="money-cell">{currencyFormatter({ 
        currency: "USD", value: invoicedTotal })}</td>
      <td style={styleCenterTable} className="money-cell">{currencyFormatter({ 
        currency: "USD", value: difference })}</td>
      <td style={styleCenterTable} className="text-cell">
        {item?.user?.first_name}
      </td>
      <td style={styleCenterTable} className="text-center">{renderPrintButton()}</td>
    </tr>
  )
}

CashCutItemList.propTypes = {
  item: propTypes.object,
  variant: propTypes.string,
  onView: propTypes.func,
}

export default CashCutItemList
